<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <!-- page Title -->
      <i-card-vertical :headerTitle="editingData.__created__ ? '안전관리 문서 관리 추가' : '안전관리 문서 관리 상세'" device="web">
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <v-card color="inner_card_bg" class="overflow-y-auto">
              <v-list class="pa-0 contents-menu">
                <v-list-item-group v-model="selectedKey" mandatory color="radio">
                  <v-list-item v-for="(item, index) in tabList" :key="index" :class="{ active: index == selectedKey }">
                    <v-list-item-content>
                      {{ item.name }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>

            <!-- 우측 테이블 영역 -->

            <v-card class="overflow-y-auto" :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <v-form ref="form">
                <!--v-row no-gutters>
                  <v-col md="12" lg="5">
                    <div class="editor-label">사업장</div>
                    <v-select v-model="editingData.compId" :items="compList" item-text="compNm" item-value="compId" solo class="editor_bg" disabled>
                      <template v-slot:selection="{ item }">
                        <div class="text-center">{{ item.compNm }}</div>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content @click="$emit('click', item.compId)">
                          <v-list-item-title>{{ item.compNm }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </v-col>
                </v-row-->
                <v-row no-gutters>
                  <v-col cols="12" class="mt-5">
                    <div class="editor-label required">안전관리 문서명</div>
                    <v-text-field v-model="editingData.manageDocNm" solo class="editor_bg" :rules="rules" />
                  </v-col>
                </v-row>
              </v-form>
              <div v-show="selectedKey === 0 || selectedKey === 1">
                <v-expansion-panels accordion flat class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header>일반</v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <iFileManage ref="detailFileUpload1" id="fileManage1" :targetId="targetId1" targetType="00015" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-show="selectedKey === 0 || selectedKey === 2">
                <v-expansion-panels accordion flat class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header>설비</v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <iFileManage ref="detailFileUpload2" id="fileManage2" :targetId="targetId2" targetType="00015" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-show="selectedKey === 0 || selectedKey === 3">
                <v-expansion-panels accordion flat class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header>안전장비</v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <iFileManage ref="detailFileUpload3" id="fileManage3" :targetId="targetId3" targetType="00015" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-show="selectedKey === 0 || selectedKey === 4">
                <v-expansion-panels accordion flat class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header>기자재</v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <iFileManage ref="detailFileUpload4" id="fileManage4" :targetId="targetId4" targetType="00015" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-show="selectedKey === 0 || selectedKey === 5">
                <v-expansion-panels accordion flat class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="text-center">보건관리비</v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <iFileManage ref="detailFileUpload5" id="fileManage5" :targetId="targetId5" targetType="00015" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div v-show="selectedKey === 0 || selectedKey === 6">
                <v-expansion-panels accordion flat class="mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header>기타</v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <iFileManage ref="detailFileUpload6" id="fileManage6" :targetId="targetId6" targetType="00015" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-card>
          </v-sheet>
        </template>
      </i-card-vertical>
      <!-- 좌측 tab -->

      <i-card-right :useBtnList="buttonUseList" @btnSave="btnSave()" @btnSearch="btnSearch()">
        <template v-slot:customBtn>
          <i-icon-button color="btn_text" :text="'목록으로'" height="92px" :icon="'back'" @click="btnCancel()" :appendDivider="true"> </i-icon-button>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import notify from 'devextreme/ui/notify'
import { getCompanyList } from '@/api/baseManage/compManage'
import { saveSafetyManageDoc } from '@/api/safetyManage/safetyManageDoc.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: { iFileManage },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true
          return '필수입력 값입니다.'
        },
      ],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
      ],
      compList: [],
      editingData: {},
      selectedKey: 0,
      tabList: [
        {
          name: '전체',
        },
        {
          name: '일반',
        },
        {
          name: '설비',
        },
        {
          name: '안전장비',
        },
        {
          name: '기자재',
        },
        {
          name: '보건관리비',
        },
        {
          name: '기타',
        },
      ],
      targetId: '',
    }
  },
  computed: {
    mobileTrigger() {
      return this.width < 800
    },
    targetId1() {
      return this.targetId && `${this.targetId}_00001`
    },
    targetId2() {
      return this.targetId && `${this.targetId}_00002`
    },
    targetId3() {
      return this.targetId && `${this.targetId}_00003`
    },
    targetId4() {
      return this.targetId && `${this.targetId}_00004`
    },
    targetId5() {
      return this.targetId && `${this.targetId}_00005`
    },
    targetId6() {
      return this.targetId && `${this.targetId}_00006`
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
  },
  beforeMount() {
    Promise.all([getCompanyList({ clntId: this.getClntId() })]).then((response) => {
      let failedResponse = response.find((element) => !element.success)
      if (failedResponse == null) {
        this.compList = response[0].list
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'error')
      }
    })
  },
  mounted() {},
  activated() {
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }
    this.editingData = this.$route.params.data
    this.selectedKey = 0
    this.targetId = this.editingData.__created__
      ? ''
      : `${this.editingData.clntId}_${this.editingData.compId}_${this.editingData.writeDt}_${this.editingData.docNo}`
    if (!this.editingData.__created__) {
      this.$nextTick(() => {
        this.btnSearch()
      })
    }
  },
  methods: {
    btnSearch() {
      this.openLoading('searching')
      Promise.all([
        this.$refs.detailFileUpload1.internalSearch(),
        this.$refs.detailFileUpload2.internalSearch(),
        this.$refs.detailFileUpload3.internalSearch(),
        this.$refs.detailFileUpload4.internalSearch(),
        this.$refs.detailFileUpload5.internalSearch(),
        this.$refs.detailFileUpload6.internalSearch(),
      ])
        .then(() => {
          notify('조회되었습니다.', 'success', 300)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnSave() {
      const validate = this.$refs.form.validate()

      if (!validate) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'warn')
        return
      }
      this.openLoading('saving')
      this.editingData.createdBy = this.getUserCd()
      saveSafetyManageDoc(this.editingData, true)
        .then((response) => {
          this.editingData = response
          this.targetId = `${this.editingData.clntId}_${this.editingData.compId}_${this.editingData.writeDt}_${this.editingData.docNo}`
          this.$store.state.ui.searchFlag = true
          return this.$nextTick()
        })
        .then(() =>
          Promise.all([
            this.$refs.detailFileUpload1.internalSave(),
            this.$refs.detailFileUpload2.internalSave(),
            this.$refs.detailFileUpload3.internalSave(),
            this.$refs.detailFileUpload4.internalSave(),
            this.$refs.detailFileUpload5.internalSave(),
            this.$refs.detailFileUpload6.internalSave(),
          ])
        )
        .finally(() => {
          this.endLoading()
        })
    },
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async (current) => {
        const toRouter = {
          name: 'SafetyManageDoc',
          params: {
            search: true,
          },
        }
        this.$router.push(toRouter)
        return
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTitle {
  width: 15%;
}

.v-data-table {
  border: 1px solid grey;
}

.selected {
  background-color: lightblue; /* 선택된 항목에 배경색을 설정합니다. */
}
</style>
